<script setup lang="ts">
import YouTubeEmbed from "~/components/articles/blocks/YouTubeEmbed.vue";
import TextBlock from "~/components/articles/blocks/TextBlock.vue";

const props = defineProps({
    articleContentBlocks: {
        type: Array as PropType<ArticleContentBlock[]>,
        required: true,
    },
});

type ArticleContentBlock = {
    type: string;
};
const blockTypes = {
    text: TextBlock,
    youtube_embed: YouTubeEmbed,
};
</script>

<template>
    <div>
        <div v-for="(block, index) in articleContentBlocks" :key="index">
            <Component :is="blockTypes[block.type] ?? 'text'" v-bind="block" />
        </div>
    </div>
</template>

<style scoped>
@reference "~/assets/css/styles.css";

:deep(p) {
    @apply mb-4;
}

:deep(h2),
:deep(h3),
:deep(h4),
:deep(h5) {
    @apply text-abc-blue mb-2 font-bold;
}
</style>
